import React from "react";
import glamorous from "glamorous";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Button } from "react-bootstrap";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Cog from "react-icons/lib/fa/cog";
import Plus from "react-icons/lib/md/add";

import SearchBar from "../../vendor/signal-widgets/components/search-bar";
import { getColumns } from "./LocationsColumns";
import { datatableThStyles, styleify } from "../../styles/table-styles";
import Colors from "../../styles/colors";
import EditLadsContainer from "../lads/EditLadsContainer";
import { ADD_LOCATION_ID } from "../locations/LocationsState";
import { Privileges, hasPrivileges } from "../auth/authorization";

const Section = glamorous.section({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "1em"
});

export default class LocationsView extends React.Component {
  render() {
    const { locations, lads, searchStr, setSearchStr } = this.props;
    const readOnly = !hasPrivileges([Privileges.MANAGE_LOCATIONS]);

    const filteredLocations = searchStr
      ? locations.filter(l => {
          return (
            (l.name &&
              l.name.toLowerCase().includes(searchStr.toLowerCase())) ||
            (l.address &&
              l.address.toLowerCase().includes(searchStr.toLowerCase())) ||
            (l.city &&
              l.city.toLowerCase().includes(searchStr.toLowerCase())) ||
            (l.state &&
              l.state.toLowerCase().includes(searchStr.toLowerCase())) ||
            (l.postal_code &&
              l.postal_code.toLowerCase().includes(searchStr.toLowerCase())) ||
            (l.code && l.code.toLowerCase().includes(searchStr.toLowerCase()))
          );
        })
      : locations;

    const columns = getColumns(lads);

    const tabs = (
      <TabList
        style={{
          display: "flex",
          flexDirection: "row",
          marginBottom: 0,
          border: "none"
        }}
      >
        <Tab
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-around",
            padding: "0.5em",
            marginRight: "0.5em"
          }}
        >
          <glamorous.Div
            css={{
              display: "flex",
              flexDirection: "row",
              lineHeight: "2em",
              color: Colors.background.GRAY_BLUE
            }}
          >
            <glamorous.Div
              css={{
                fontSize: "1.3em",
                color: Colors.highlight.GREEN,
                marginRight: "0.25em"
              }}
            >
              {`${locations.length}`}
            </glamorous.Div>
            <glamorous.Div css={{ marginTop: "1px" }}>Locations</glamorous.Div>
          </glamorous.Div>
        </Tab>

        <Tab
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-around",
            padding: "0.5em"
          }}
        >
          <glamorous.Div css={{ color: Colors.background.GRAY_BLUE }}>
            <Cog size="1.5em" /> Edit LAD Labels
          </glamorous.Div>
        </Tab>
      </TabList>
    );

    const tableTrProps = (state, rowInfo, column, instance) => {
      return {
        onClick: e => {
          const locID = rowInfo.original.id;
          this.props.pushLocationEditScreen(locID);
        },
        style: { cursor: "pointer" }
      };
    };

    return (
      <Section>
        <Tabs>
          {tabs}

          <TabPanel>
            <glamorous.Div
              css={{
                display: "flex",
                flex: 1,
                flexDirection: "row",
                marginTop: "1em"
              }}
            >
              <SearchBar
                placeholder={"Search for location"}
                searchStr={searchStr}
                eventHandler={(val, type) => setSearchStr(val)}
              />
              {readOnly ? null : (
                <Button
                  style={{
                    backgroundColor: Colors.highlight.GREEN,
                    color: "white",
                    fontWeight: "300",
                    height: "3em",
                    marginLeft: "0.5em"
                  }}
                  onClick={() =>
                    this.props.pushLocationEditScreen(ADD_LOCATION_ID)
                  }
                >
                  <Plus size="2em" /> Add New Location
                </Button>
              )}
            </glamorous.Div>

            <ReactTable
              data={filteredLocations}
              columns={columns}
              getTheadThProps={styleify(datatableThStyles)}
              getTrProps={tableTrProps}
              filterable
            />
          </TabPanel>

          <TabPanel>
            <EditLadsContainer />
          </TabPanel>
        </Tabs>
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/locations/LocationsView.js